import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { SportySkyCountry } from '../../models/SportySky/sportySkyCountry';
import { SportySkyByDepart } from '../../models/SportySky/sportySkyDepart';
import { SportySky } from '../../models/SportySky/spotSportySky';

@Injectable({
  providedIn: 'root'
})
export class SportySkyService {

  constructor(private http: HttpClient) { }

  getAllByCountry(): Observable<SportySkyCountry> {
    const params = new HttpParams()
      .set('countryIsoCode', 'FR');

    return this.http.get<SportySkyCountry>(`${environment.apiUrl}/SportySky/forecast`, { params });
  }

  getAllByDepartement(): Observable<SportySkyByDepart> {
    const params = new HttpParams()
      .set('departmentIsoCode', 'FR-59');

    return this.http.get<SportySkyByDepart>(`${environment.apiUrl}/SportySky/forecast`, { params });
  }

  getSpot() {
    return this.http.get<SportySky>(`${environment.apiUrl}/SportySky/spot`);

  }


}
